// Memory-only proof of which bearer session actually fetched a profile.
type VerifiedProfile = Readonly<{
  userId: number
  generation: number
}>
let current: VerifiedProfile | null = null
let verifiedToken: string | null = null
const listeners = new Set<() => void>()
let generation = 0

export const verifiedProfile = {
  read: () => current,
  matches: (token: string) => verifiedToken === token && current !== null,
  subscribe: (listener: () => void) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
}

export function confirmVerifiedProfile(userId: number, token: string) {
  if (verifiedToken === token && current?.userId === userId) return
  verifiedToken = token
  current = { userId, generation: ++generation }
  listeners.forEach((listener) => listener())
}

export function invalidateVerifiedProfile() {
  verifiedToken = null
  current = null
  listeners.forEach((listener) => listener())
}
